import {
	Box,
	Button,
	Grid,
	Link,
	List,
	alpha,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { useState } from 'react';
import AuthApis from '../../hepler/authApis.service';
import { toast } from 'react-toastify';
import FipVerifiedHeading from './FipVerifiedHeading';
import { useRef } from 'react';
import styles from './FipDiscoveredAccountsSection.styles';
import sizeFontCustom from './fontSize.styles';
import FipDiscoveredAccounts from './FipDiscoveredAccounts';
import VerifyOtp from './VerifyOtp';
import Drawer from '../Drawer/Drawer';
import { isAccountLinked, getUniqueKey } from '../../utils/helper.utils';
import { trackEvent } from '../../utils/tracking.utils';
import { postMessage } from '../../utils/common.utils';
import { CircularProgress } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

function FipDiscoveredAccountsSection(props) {
	const { t } = useTranslation();
	const [linkAccountButtonDisabled, setLinkAccountButtonDisabled] =
		useState(false);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	// Check for dark theme
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const authApis = new AuthApis();

	const fipId = props.accountsSingleFip.fipId;
	const fipAccountsAll = props.accountsSingleFip.discoveredAccounts.flat(1);

	const phoneNumber = props.accountsSingleFip.phoneNumber;

	let accountsNotLinkedSet = new Set();
	let accountsNotLinked = fipAccountsAll.filter((acc) => {
		const uniqueKey = getUniqueKey(acc, fipId);

		if (!accountsNotLinkedSet.has(uniqueKey)) {
			accountsNotLinkedSet.add(uniqueKey);
			return !isAccountLinked(
				acc,
				props.accountState.linkedAccountsFull,
				fipId
			);
		}
		return false;
	});

	const isMultiTokenLinking = () => {
		const path = window.location.href.split('/').pop();
		if (path.includes(',')) {
			trackEvent('MULTIPLE_FIP_LINKING', {
				totalFips: path.split(',').length,
				count: path.split(',').length,
			});
		}
		return path.includes(',');
	};

	let accountsLinkedSet = new Set();
	let accountsLinked = fipAccountsAll.filter((acc) => {
		const uniqueKey = getUniqueKey(acc, fipId);
		if (!accountsLinkedSet.has(uniqueKey)) {
			accountsLinkedSet.add(uniqueKey);
			return isAccountLinked(acc, props.accountState.linkedAccountsFull, fipId);
		}
		return false;
	});

	const [selectedAccounts, setSelectedAccounts] = useState(accountsNotLinked);
	// eslint-disable-next-line no-unused-vars
	const [checkedItems, setCheckedItems] = useState({});
	// const [showChangeNumber, setShowChangeNumber] = useState(false)
	const [showAll, setShowAll] = useState(false);
	const [verifyState, setVerifyState] = useState({
		isProceed: true,
		isResend: true,
		isDisable: false,
		OTP: null,
		linkingRefNO: '',
		time: 60,
		linkedStatus: [],
		fipId: '',
	});

	// const handleChangeNumber = () => {
	//   props.setChangingMobileNumber(true)
	//   setShowChangeNumber(true)
	// }
	const id = useRef('');
	const initiate = () => {
		setVerifyState((prevState) => {
			const newTime = prevState.time - 1;
			if (newTime === 0) {
				clearInterval(id.current);
				return { ...prevState, time: 60, isResend: true };
			}
			return { ...prevState, time: newTime };
		});
	};
	const setResend = () => {
		clearInterval(id.current);
		id.current = setInterval(initiate, 1000);
	};
	const accountLinking = () => {
		setVerifyState({ ...verifyState, isDisable: true, isResend: false });
		const accountsToLink = selectedAccounts.map(
			({ restrictions, ...accountWithoutRestrictions }) =>
				accountWithoutRestrictions
		);
		return authApis
			.accountLinking(
				fipId,
				global.redirectAccountRestrictions ? accountsToLink : selectedAccounts
			)
			.then((res) => {
				setVerifyState({ ...verifyState, isDisable: false });
				if (!res) {
					toast.error(t('errors.general.somethingWentWrong'));
					return res;
				}
				if (res.status === 'SUCCESS') {
					setVerifyState({
						...verifyState,
						isProceed: false,
						isResend: false,
						OTP: '',
						linkingRefNO: res.RefNumber,
						fipId: fipId,
					});
					setResend();
				} else {
					setVerifyState({ ...verifyState, isResend: true });
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}

					if (res.status === 'FAILURE' && res.message === 'Session Error.') {
						setTimeout(() => {
							props.history.push({
								pathname: `/consent-status`,
								state: {
									statusCode: 20,
								},
							});
						}, 3000);
					}
				}
				return res;
			})
			.catch((error) => {
				setVerifyState({ ...verifyState, isDisable: false, isResend: true });
				toast.error(t('errors.general.failedToLink'));
			});
	};

	const accountConfirmLinking = () => {
		isMultiTokenLinking();
		setVerifyState({ isDisable: true, isResend: false });
		authApis
			.accountConfirmLinking(
				verifyState.linkingRefNO,
				verifyState.OTP,
				verifyState.fipId
			)
			.then((res) => {
				if (res.status === 'SUCCESS') {
					const linkedAccounts = res?.AccLinkDetails.map(
						(acc) => acc.accRefNumber
					);
					const newLinkedAccounts = selectedAccounts.map((account) => ({
						fipId: account.fipId,
						accType: account.accType,
						FIType: account.FIType,
						maskedAccNumber: account.maskedAccNumber,
					}));
					setVerifyState({
						...verifyState,
						isDisable: false,
						isResend: true,
						linkedStatus: linkedAccounts,
					});
					if (props.setAllLinkedAccounts) {
						props.setAllLinkedAccounts((prev) => [
							...prev,
							...newLinkedAccounts,
						]);
					}
					toast.success(res.message);
					// props.history.push(`/payment-consent`);
					props.setAccountsNotLinkedLength(
						(prev) => prev - linkedAccounts.length
					);

					props.setSelectedAccountLinkedLength((prev) => prev + 1);
				} else {
					setVerifyState({
						...verifyState,
						OTP: '',
					});
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
					if (res.status === 'FAILURE') {
						postMessage('session', 'FAILURE');
					}
				}
			});
	};

	const handleVerify = () => {
		setLinkAccountButtonDisabled(true);
		accountLinking().finally(() => {
			setLinkAccountButtonDisabled(false);
		});
	};
	const handleCheckedState = (event, account) => {
		selectUnselectAcc(account);
		const { name, checked } = event.target;
		setCheckedItems((prevCheckedItems) => ({
			...prevCheckedItems,
			[name]: checked,
		}));
	};
	const selectUnselectAcc = (account) => {
		let data = [...selectedAccounts]; // Create a new array instead of mutating the existing one
		const existingAccountIndex = data.findIndex(
			(acc) => acc.accRefNumber === account.accRefNumber
		);
		if (existingAccountIndex !== -1) {
			// Account exists, remove it
			data.splice(existingAccountIndex, 1);
		} else {
			// Account doesn't exist, add it
			data.push(account);
		}
		setSelectedAccounts(data); // Now React will detect the state change
	};

	const toggleShowAll = () => {
		setShowAll((prev) => !prev);
	};

	return (
		<Grid item xs={12} sm={8} md={8} lg={5.5}>
			<List
				sx={{
					background: isDark ? '#2D2D2D' : theme.palette.primary.white,
					color: isDark ? '#FFFFFF' : '#000000',
					justifyContent: 'start',
					alignItems: 'start',
					borderRadius: '1rem',
					padding: '0.5rem',
					border: 'none',
				}}
			>
				<FipVerifiedHeading
					allLinked={
						accountsNotLinked.length === 0 && accountsLinked.length > 0
					}
					isVerified={verifyState.linkedStatus}
					fipId={fipId}
					phoneNumber={phoneNumber}
					areAccountsDiscovered={fipAccountsAll.length > 0}
				/>
				{fipAccountsAll.length === 0 ? (
					<></>
				) : (
					<Box
						sx={{
							...styles.discoveredAccounts,
							maxHeight: showAll ? 'auto' : '10rem',
							'&::-webkit-scrollbar-thumb': {
								backgroundColor: alpha(theme.palette.primary.main, 0.5),
								borderRadius: '10px',
							},
						}}
					>
						{accountsNotLinked.length > 0
							? accountsNotLinked.map((account) => {
									return (
										<FipDiscoveredAccounts
											account={account}
											fipId={fipId}
											handleCheckedState={handleCheckedState}
											selectedAccounts={selectedAccounts}
											isVerified={verifyState.linkedStatus}
											isLinked={false}
											customDetails={props.customDetails}
										/>
									);
							  })
							: accountsLinked.map((account) => {
									return (
										<FipDiscoveredAccounts
											account={account}
											fipId={fipId}
											isVerified={verifyState.linkedStatus}
											handleCheckedState={handleCheckedState}
											selectedAccounts={selectedAccounts}
											isLinked={true}
											customDetails={props.customDetails}
										/>
									);
							  })}
					</Box>
				)}
				{accountsNotLinked.length === 0 && (
					<Box
						display={accountsLinked.length - 2 > 0 ? 'block' : 'none'}
						textAlign={'start'}
					>
						<Link
							display="block"
							underline="none"
							sx={{
								cursor: 'pointer',
								...sizeFontCustom.subHeading,
								mt: '0.1rem',
								ml: '1rem',
								color: isDark ? '#FFFFFF' : 'inherit',
							}}
							onClick={toggleShowAll}
						>
							{showAll
								? t('common.buttons.showLess')
								: `+ ${accountsLinked.length - 2} ${t(
										'common.buttons.showMore'
								  )}`}
						</Link>
					</Box>
				)}
				<Box
					display={accountsNotLinked.length - 2 > 0 ? 'block' : 'none'}
					textAlign={'start'}
				>
					<Link
						display="block"
						underline="none"
						sx={{
							cursor: 'pointer',
							...sizeFontCustom.subHeading,
							mt: '0.1rem',
							ml: '1rem',
							color: isDark ? '#FFFFFF' : 'inherit',
						}}
						onClick={toggleShowAll}
					>
						{showAll
							? t('common.buttons.showLess')
							: `+ ${accountsNotLinked.length - 2} ${t(
									'common.buttons.showMore'
							  )}`}
					</Link>
				</Box>
				<List disablePadding sx={{ mt: '0.5rem' }}>
					{verifyState.linkedStatus?.length === 0 &&
					accountsNotLinked.length > 0 ? (
						verifyState.isProceed ? (
							<Box mx={'1rem'}>
								<Button
									fullWidth
									variant="contained"
									onClick={handleVerify}
									disabled={
										selectedAccounts.length === 0 || linkAccountButtonDisabled
									}
									sx={{
										textTransform: 'capitalize',
										...sizeFontCustom.subHeading,
										my: 1,
										backgroundColor:
											props.customDetails?.ctaBackgroundColor ||
											props.customDetails?.primaryColor ||
											'#3053D3',
										color:
											props.customDetails?.ctaTextColor ||
											(isDark ? '#000000' : '#FFFFFF'),
										'&:hover': {
											backgroundColor:
												props.customDetails?.ctaHoverPrimaryColor ||
												props.customDetails?.primaryColor ||
												'#3053D3',
										},
									}}
								>
									{linkAccountButtonDisabled ? (
										<CircularProgress
											size={24}
											sx={{
												color: theme.palette.primary.white,
											}}
										/>
									) : (
										t('common.buttons.linkAccount')
									)}
								</Button>
							</Box>
						) : !mobileScreen ? (
							<VerifyOtp
								phoneNumber={phoneNumber}
								setVerifyState={setVerifyState}
								verifyState={verifyState}
								handleVerify={handleVerify}
								accountConfirmLinking={accountConfirmLinking}
								linkAccountButtonDisabled={linkAccountButtonDisabled}
							/>
						) : (
							<Drawer
								open={!verifyState.isProceed}
								setOpen={() =>
									setVerifyState({
										...verifyState,
										isProceed: true,
									})
								}
								medWidth={'30%'}
								closeBtnTop="0.35rem"
								anchor={'bottom'}
								height={'30vh'}
								customDetails={props.customDetails}
								showCloseBtn={mobileScreen ? false : true}
							>
								<VerifyOtp
									phoneNumber={phoneNumber}
									setVerifyState={setVerifyState}
									verifyState={verifyState}
									handleVerify={handleVerify}
									accountConfirmLinking={accountConfirmLinking}
									linkAccountButtonDisabled={linkAccountButtonDisabled}
								/>
							</Drawer>
						)
					) : null}
				</List>
			</List>
		</Grid>
	);
}

export default FipDiscoveredAccountsSection;
